import { tagEstado } from '../core/componentes.js';
import { contratoDe, contratosVisibles, importeDe, pedidoDe, precioDe, usuarioDe } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { cant, esc, eur, eurK, fecha, fechaCorta, num } from '../core/formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   IMPUTACIONES
   ===================================================================== */
const flecha = (campo,orden,dir) => orden===campo ? (dir==='asc'?' ↑':' ↓') : '';

export function tablaImputaciones(lista, conContrato=true, compacta=false, ordenable=false){
  if(!lista.length) return `<div class="vacio"><h4>Sin imputaciones</h4><p>Registra el primer trabajo ejecutado.</p></div>`;
  const thFecha = ordenable
    ? `<th data-act="ordenar-imp" data-campo="fecha" style="cursor:pointer;user-select:none">Fecha${flecha('fecha',S.impOrden,S.impOrdenDir)}</th>`
    : '<th>Fecha</th>';
  const thUbic = compacta ? '' : ordenable
    ? `<th data-act="ordenar-imp" data-campo="carretera" style="cursor:pointer;user-select:none">Ubicación${flecha('carretera',S.impOrden,S.impOrdenDir)}</th>`
    : '<th>Ubicación</th>';
  return `<table><thead><tr>${thFecha}${conContrato?'<th>Contrato</th>':''}<th>Unidad</th>
    ${thUbic}<th class="num">Medición</th><th class="num">Importe</th><th>Estado</th>${compacta?'':'<th>Registró</th>'}</tr></thead>
    <tbody>${lista.map(i=>{const p=precioDe(i.precio);return `<tr>
      <td class="mono" style="font-size:12.5px">${fechaCorta(i.fecha)}</td>
      ${conContrato?`<td><span class="cod">${esc(contratoDe(i.contrato).expediente)}</span></td>`:''}
      <td><span class="cod">${esc(p.codigo)}</span> <span style="color:var(--gris)">${esc(p.desc)}</span>
        ${i.pedido?`<div style="font-size:11px;color:var(--gris-claro)">Desde pedido ${esc(pedidoDe(i.pedido)?.numero||'')}</div>`:''}</td>
      ${compacta?'':`<td style="font-size:12.5px">${esc(i.carretera)}<div style="color:var(--gris-claro);font-size:11.5px" class="mono">PK ${esc(i.pk)}</div>${i.obs?`<div style="color:var(--gris-claro);font-size:11px;margin-top:2px">${esc(i.obs)}</div>`:''}</td>`}
      <td class="num">${cant(i.cantidad)} ${esc(p.ud)}</td>
      <td class="num"><b>${eur(i.cantidad*p.precio)}</b></td>
      <td>${tagEstado(i.estado)}</td>
      ${compacta?'':`<td style="font-size:12.5px;color:var(--gris)">${esc(usuarioDe(i.usuario)?.nombre||'—')}</td>`}
    </tr>`;}).join('')}</tbody></table>`;
}

export function vistaImputaciones(){
  const soloMias = S.usuario.rol==='operario';
  const contratos = contratosVisibles();
  const cs = contratos.map(c=>c.id);
  let lista = db.imputaciones.filter(i=>cs.includes(i.contrato));
  if(soloMias) lista = lista.filter(i=>i.usuario===S.usuario.id);
  if(S.filtroImpContrato!=='todos') lista = lista.filter(i=>i.contrato===S.filtroImpContrato);
  if(S.filtroImpCarretera!=='todos') lista = lista.filter(i=>i.carretera===S.filtroImpCarretera);
  if(S.impDesde) lista = lista.filter(i=>i.fecha>=S.impDesde);
  if(S.impHasta) lista = lista.filter(i=>i.fecha<=S.impHasta);
  const campo = S.impOrden, dir = S.impOrdenDir;
  lista = lista.slice().sort((a,b)=>dir==='asc' ? String(a[campo]).localeCompare(b[campo]) : String(b[campo]).localeCompare(a[campo]));
  const borradores = db.imputaciones.filter(i=>i.estado==='borrador');
  return `<div class="page-head">
    <div><div class="eyebrow">Ejecución</div><h1>Imputaciones</h1>
      <p>${soloMias?'Trabajos que has registrado tú. Cuando el administrador los valide entrarán en la siguiente certificación.':'Todo el trabajo ejecutado, volcado sobre el cuadro de precios de cada contrato.'}</p></div>
    <button class="btn btn-p" data-act="nueva-imputacion">Registrar trabajo</button></div>
  ${S.usuario.rol==='admin'&&borradores.length?`<div class="aviso a-azul"><div class="txt">
    <b class="tit">${borradores.length} imputaciones en borrador</b>Suman ${eurK(borradores.reduce((s,i)=>s+importeDe(i),0))}. Valídalas para poder certificarlas.
    <button class="btn btn-s" style="margin-top:8px" data-act="validar-todo">Validar todas</button></div></div>`:''}
  <div style="display:flex;gap:7px;margin-bottom:16px;flex-wrap:wrap;align-items:center">
    <select data-act="filtro-imp-contrato">
      <option value="todos" ${S.filtroImpContrato==='todos'?'selected':''}>Todos los contratos</option>
      ${contratos.map(c=>`<option value="${c.id}" ${S.filtroImpContrato===c.id?'selected':''}>${esc(c.expediente)} · ${esc(c.nombre)}</option>`).join('')}
    </select>
    <select data-act="filtro-imp-carretera">
      <option value="todos" ${S.filtroImpCarretera==='todos'?'selected':''}>Todas las carreteras</option>
      ${db.carreteras.map(r=>`<option ${S.filtroImpCarretera===r.nombre?'selected':''}>${esc(r.nombre)}</option>`).join('')}
    </select>
    <label style="font-size:12px;color:var(--gris);display:flex;align-items:center;gap:5px">Desde <input id="imp-desde" type="date" data-act="filtro-imp-fecha" data-tipo="desde" value="${S.impDesde}"></label>
    <label style="font-size:12px;color:var(--gris);display:flex;align-items:center;gap:5px">Hasta <input id="imp-hasta" type="date" data-act="filtro-imp-fecha" data-tipo="hasta" value="${S.impHasta}"></label>
  </div>
  <div class="card"><div class="tabla-wrap">${tablaImputaciones(lista, true, false, true)}</div></div>`;
}

